<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><em>Main Characters</em></h2>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s parents, siblings, grandmother and uncle</strong></em></p>
<p class="hangindent-para">Ahmed, King of Samarkand, Babur’s uncle</p>
<p class="hangindent-para">Esan Dawlat, Babur’s maternal grandmother</p>
<p class="hangindent-para">Jahangir, Babur’s half-brother</p>
<p class="hangindent-para">Khanzada, Babur’s older sister</p>
<p class="hangindent-para">Kutlugh Nigar, Babur’s mother</p>
<p class="hangindent-para">Umar-Shaikh, King of Ferghana, Babur’s father</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s wives</strong></em></p>
<p class="hangindent-para">Ayisha, daughter of the chief of the Mangligh clan</p>
<p class="hangindent-para">Maham, Babur’s favourite wife and mother of Humayun</p>
<p class="hangindent-para">Gulrukh, mother of Kamran and Askari</p>
<p class="hangindent-para">Bibi Mubarak, daughter of the chief of the Yusufzai clan</p>
<p class="hangindent-para">Dildar, mother of Hindal</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s sons</strong></em></p>
<p class="hangindent-para">Humayun</p>
<p class="hangindent-para">Kamran</p>
<p class="hangindent-para">Askari</p>
<p class="hangindent-para">Hindal</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s cousins</strong></em></p>
<p class="hangindent-para">Azar Khan, nobleman of Ferghana</p>
<p class="hangindent-para">Mahmud, Prince of Kunduz</p>
<p class="hangindent-para">Mirza Khan, chieftain of Ferghana</p>
<p class="hangindent-para">Tambal, nobleman of Ferghana</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s inner circle</strong></em></p>
<p class="hangindent-para">Baburi, a former market boy and Babur’s closest friend</p>
<p class="hangindent-para">Baisanghar, originally an officer of Samarkand, subsequently Babur’s loyal commander and, even later, father-in-law</p>
<p class="hangindent-para">Kasim, one of Babur’s political advisers, often used by him as an ambassador</p>
<p class="hangindent-para">Wazir Khan, milk-brother to Babur’s father and Babur’s guide and chief mentor in his childhood and early years as king</p>
<p class="hangindent-para">Abdul-Malik, a physician</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Ferghana</strong></em></p>
<p class="hangindent-para">Baba Qashqa, comptroller of the royal household</p>
<p class="hangindent-para">Baqi Beg, court astrologer</p>
<p class="hangindent-para">Fatima, chief waiting woman</p>
<p class="hangindent-para">Qambar-Ali, vizier</p>
<p class="hangindent-para">Rehana, an old woman whose grandfather rode with Timur to sack Delhi</p>
<p class="hangindent-para">Roxanna, concubine of Babur’s father and mother of Jahangir</p>
<p class="hangindent-para">Walid Butt, Esan Dawlat’s steward</p>
<p class="hangindent-para">Yadgar, Babur’s favourite inhabitant of a Ferghana brothel</p>
<p class="hangindent-para">Yusuf, keeper of the treasury</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s tribal leaders</strong></em></p>
<p class="hangindent-para">Ali-Dost, a chieftain from western Ferghana</p>
<p class="hangindent-para">Ali Gosht, Babur’s master-of-horse and later chief quartermaster</p>
<p class="hangindent-para">Ali Mazid Beg, lord of Shahrukiyyah</p>
<p class="hangindent-para">Baba Yasaval, warrior from near Herat</p>
<p class="hangindent-para">Hussain Mazid, headman of Sayram and cousin of Ali Mazid Beg</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s chief enemy in Central Asia</strong></em></p>
<p class="hangindent-para">Shaibani Khan, powerful leader of the Uzbek clans and blood enemy of Babur’s people and all those descended from Timur</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Persia</strong></em></p>
<p class="hangindent-para">Shah Ismail of Persia</p>
<p class="hangindent-para">Mullah Husayn, Shiite mullah serving Shah Ismail</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Turkey</strong></em></p>
<p class="hangindent-para">Ali-Quli, master-gunner</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Kabul</strong></em></p>
<p class="hangindent-para">Bahlul Ayyub, grand vizier</p>
<p class="hangindent-para">Haydar Taqi, keeper of the Royal Seal</p>
<p class="hangindent-para">Muhammad-Muquim Arghun, chief of the Hazaras</p>
<p class="hangindent-para">Wali Gul, guardian of the Royal Treasuries</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Hindustan</strong></em></p>
<p class="hangindent-para">Buwa, mother of Sultan Ibrahim Lodi</p>
<p class="hangindent-para">Firoz Khan, Hindustani warlord</p>
<p class="hangindent-para">Gwalior royal family, owners of the Koh-i-Nur diamond, the ‘Mountain of Light’</p>
<p class="hangindent-para">Rana Sanga, Hindu ruler of the Rajput state of Mewar</p>
<p class="hangindent-para">Sultan Ibrahim Lodi, ruler of the great Delhi Sultanate and overlord of Hindustan</p>
<p class="hangindent-para">Roshanna, Buwa’s serving woman</p>
<p class="linespace"> </p>
<p class="hangindent-para"><em><strong>Babur’s ancestors</strong></em></p>
<p class="hangindent-para">Genghis Khan</p>
<p class="hangindent-para">Timur, known in the West as Tamburlaine from a corruption of ‘Timur-i-Lang’, ‘Timur the Lame’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?b2bf458e